import React from "react";
import {useTranslation} from "../../i18n/LanguageProvider";
import { useNavigate } from "react-router-dom";

interface GroupTripButtonProps {
  expanded?: boolean;
}

const GroupTripButton: React.FC<GroupTripButtonProps> = ({ expanded = false }) => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/group-planning");
  };

  return (
    <div
      onClick={handleClick}
      className="flex bg-[#712FFF] rounded-2xl shadow-lg z-10 p-5 h-fit text-white cursor-pointer transform transition-transform duration-200 hover:scale-105"
    >
      <div className="flex justify-between gap-2 items-center w-full">
        <div className="flex flex-col items-start text-start">
          <h3 className="text-sm font-bold text-white">{t("groupTrip.title")}</h3>
          {expanded && (
            <p className="text-xs font-bold text-[#E3D5FF] mt-1">
              {t("groupTrip.description").split("\n").map((line, index) => (
                <React.Fragment key={line}>
                  {index > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </p>
          )}
        </div>
        <div className="bg-white text-[#712FFF] text-xs font-bold px-2 py-1 tracking-tight rounded-full">
          {t("groupTrip.soon")}
        </div>
      </div>
    </div>
  );
};

export default GroupTripButton;
